import React, { PropsWithChildren, ReactElement } from "react";
import RankingSideIcon from "@icons/rankingSideIcon.svg";

export const Ranking = (props: PropsWithChildren): ReactElement => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0px",
        gap: "8px",
      }}
    >
      <RankingSideIcon style={{ transform: "matrix(-1, 0, 0, 1, 0, 0)" }} />
      {props.children}
      <RankingSideIcon />
    </div>
  );
};
